module.exports = __webpack_public_path__ + "img/earth-en.baedf0a3.png";